import { gql } from "@apollo/client";

export const GET_FACETS = gql`
  query GetOffers(
    $qapiToken: String!
    $countryCode: Country!
    $languageCode: Language!
    $offset: Int!
  ) {
    search(
      qapiToken: $qapiToken
      countryCode: $countryCode
      languageCode: $languageCode
      filters: {}
      order: SCORE_DESC
      pagination: { offset: $offset, limit: 10 }
    ) {
      facets {
        countrySourceName {
          value
          countOffers
          count
          minPrice
          regionSourceName {
            count
            value
            citySourceName {
              count
              value
            }
          }
        }
      }
    }
  }
`;
